var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_843782_play_google_appstore_android_icon",
    "data-name": " 843782 play google appstore android icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8249",
    "data-name": "Path 8249",
    className: "cls-1",
    d: "M28.45,12.27,7.57,1.09A4,4,0,0,0,4.29.85L22.08,18.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8250",
    "data-name": "Path 8250",
    className: "cls-1",
    d: "M36.24,16.44l-6-3.22L23.44,20l6.79,6.79,6-3.22A4,4,0,0,0,37.9,18.1,4.08,4.08,0,0,0,36.24,16.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8251",
    "data-name": "Path 8251",
    className: "cls-1",
    d: "M2.66,1.94a4,4,0,0,0-1,2.71v30.7a4,4,0,0,0,1,2.71L20.72,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8252",
    "data-name": "Path 8252",
    className: "cls-1",
    d: "M4.29,39.15a4,4,0,0,0,3.28-.24L28.45,27.73l-6.37-6.37Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.18e67d240f49613bc97bb8e3018ef227.svg";
export { ForwardRef as ReactComponent };